const config = {
  isProd: process.env.REACT_APP_ENV === "production",
  production: {
    api_endpoint: process.env.REACT_APP_PRODUCTION_API_ENDPOINT || "https://us.darveys.com/index.php/mobileappbuilder/apicall",
    stripe_key: "pk_live_51NxqQVGWly3LhywlzCjqiQoHoTNNpL9WFTfHh8xNUcEsHSpRUB3LfwoN2gqB3JkRm2i8ALbEZqSRhYcSm0ArBZx900smE22lSg",
  },
  development: {
    api_endpoint: process.env.REACT_APP_DEVELOPMENT_API_ENDPOINT || "https://stagingus.darveys.com/index.php/mobileappbuilder/apicall",
    stripe_key: "pk_test_51NxqQVGWly3Lhywl1ffFDkoQbWqgwwQ56WSDXcbVjLnbbQcBxvEtoNIuiRcdUdx6cSGezQUNyDEgfMKTc5de0Nuw00euJrB704",
  },
  version: '1.11',
  skinURL: "https://skin.darveys.com",
  syncProduction: {
    api_endpoint: ["https://www.darveys.com/index.php/mobileappbuilder/apicall"]
  },
};

export default config;
